import { Toast } from "@capacitor/toast";

export const handleCopy = async (text: string): Promise<void> => {
	try {
		await navigator.clipboard.writeText(text);
		await Toast.show({
			text: "Skopiowano do schowka!",
			duration: "short",
			position: "bottom",
		});
	} catch {
		await Toast.show({
			text: "Błąd kopiowania",
			duration: "short",
			position: "bottom",
		});
	}
};
